import React from "react";
import CardMain from "./CardMain";
import { Grid, makeStyles } from "@material-ui/core";
import DashboardAdmin from "../DashboardAdmin";
import ContentCardProfile from "./ContentCardProfile";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-evenly",
    marginTop: "20px",
  },
}));

export default function MainInsights() {
  const classes = useStyles();

  return (
    <DashboardAdmin>
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={12} className={classes.root}>
            <CardMain title="Company Profile">
              <ContentCardProfile />
            </CardMain>
            <CardMain title="Staff Members" />
            <CardMain title="Consultations" />
          </Grid>
        </Grid>
      </div>
    </DashboardAdmin>
  );
}
